import LayoutAdmin from "@/layouts/layoutAdmin.vue";
import ledger from "@/views/module/accounts/reports/ledger.vue";
import customerLedger from "@/views/module/accounts/reports/customer_ledger.vue";
import supplierLedger from "@/views/module/accounts/reports/supplier_ledger.vue";
import dayBook from "@/views/module/accounts/reports/dayBook.vue";
import cashBook from "@/views/module/accounts/reports/cashBook.vue";
import bankBook from "@/views/module/accounts/reports/bankBook.vue";
import trialBalance from "@/views/module/accounts/reports/trialBalance.vue";
import balanceSheet from "@/views/module/accounts/reports/balanceSheet.vue";
import incomeStatement from "@/views/module/accounts/reports/incomeStatement.vue";
import receiptPaymentStatement from "@/views/module/accounts/reports/receiptPaymentStatement.vue";
import chartOfAccountSetup from "@/views/module/accounts/settingsManagement/chartOfAccountSetup.vue";
import costCenterSetup from "@/views/module/accounts/settingsManagement/costCenterSetup.vue";
import addJournalVoucher from "@/views/module/accounts/journalVoucher/addJournalVoucher.vue";
import journalVoucherList from "@/views/module/accounts/journalVoucher/journalVoucherList.vue";

import addReceiptVoucher from "@/views/module/accounts/receiptVoucher/addReceiptVoucher.vue";
import receiptVoucherList from "@/views/module/accounts/receiptVoucher/receiptVoucherList.vue";
import addcontraVoucher from "@/views/module/accounts/contraVoucher/addcontraVoucher.vue";
import contraVoucherList from "@/views/module/accounts/contraVoucher/contraVoucherList.vue";
import addPaymentVoucher from "@/views/module/accounts/paymentVoucher/addPaymentVoucher.vue";
import paymentVoucherList from "@/views/module/accounts/paymentVoucher/paymentVoucherList.vue";
import addRefundPayVoucher from "@/views/module/accounts/refundPayVoucher/addRefundPayVoucher.vue";
import refundPayVoucherList from "@/views/module/accounts/refundPayVoucher/refundPayVoucherList.vue";
import addDebitNoteVoucher from "@/views/module/accounts/debitNoteVoucher/addDebitNoteVoucher.vue";
import debitNoteVoucherList from "@/views/module/accounts/debitNoteVoucher/debitNoteVoucherList.vue";
import addCreditNoteVoucher from "@/views/module/accounts/creditNoteVoucher/addCreditNoteVoucher.vue";
import creditNoteVoucherList from "@/views/module/accounts/creditNoteVoucher/creditNoteVoucherList.vue";
import addPurchaseVoucher from "@/views/module/accounts/PurchaseVoucher/addPurchaseVoucher.vue";
import purchaseVoucherList from "@/views/module/accounts/PurchaseVoucher/purchaseVoucherList.vue";
import addSalesVoucher from "@/views/module/accounts/salesVoucher/addSalesVoucher.vue";
import salesVoucherList from "@/views/module/accounts/salesVoucher/salesVoucherList.vue";
import addRefundReceiveVoucher from "@/views/module/accounts/refundReceiveVoucher/addRefundReceiveVoucher.vue";
import refundReceiveVoucherList from "@/views/module/accounts/refundReceiveVoucher/refundReceiveVoucherList.vue";
import addOpeningBalanceVoucher from "@/views/module/accounts/openingBalanceVoucher/addOpeningBalanceVoucher.vue";
import openingBalanceVoucherList from "@/views/module/accounts/openingBalanceVoucher/openingBalanceVoucherList.vue";
import viewOpeningBalanceVoucher from "@/views/module/accounts/openingBalanceVoucher/viewOpeningBalanceVoucher.vue";
import payeeDepositorParty from "@/views/module/accounts/party/payeeDepositorParty.vue";

import cashFlowStatement from '@/views/module/accounts/reports/cashFlowStatement.vue';
import changesInEquity from '@/views/module/accounts/reports/changesInEquity.vue';
import viewJournalVoucher from "@/views/module/accounts/journalVoucher/viewJournalVoucher.vue";
import viewReceiptVoucher from "@/views/module/accounts/receiptVoucher/viewReceiptVoucher.vue";
import viewContraVoucher from "@/views/module/accounts/contraVoucher/viewContraVoucher.vue";
import viewPaymentVoucher from "@/views/module/accounts/paymentVoucher/viewPaymentVoucher.vue";
import viewDebitNoteVoucher from "@/views/module/accounts/debitNoteVoucher/viewDebitNoteVoucher.vue";
import viewCreditNoteVoucher from "@/views/module/accounts/creditNoteVoucher/viewCreditNoteVoucher.vue";
import viewRefundReceiveVoucher from "@/views/module/accounts/refundReceiveVoucher/viewRefundReceiveVoucher.vue";
import viewRefundPayVoucher from "@/views/module/accounts/refundPayVoucher/viewRefundPayVoucher.vue";
import viewPurchaseVoucher from "@/views/module/accounts/PurchaseVoucher/viewPurchaseVoucher.vue";
import viewSalesVoucher from "@/views/module/accounts/salesVoucher/viewSalesVoucher.vue";
import vatRegister from "@/views/module/accounts/vatBook/vatRegister.vue";
import taxRegister from "@/views/module/accounts/taxBook/taxRegister.vue";
import bankReconcilationRecord from "@/views/module/accounts/bankReconcilation/bankReconcilationRecord.vue";
import bankReconcilationStatement from "@/views/module/accounts/bankReconcilation/bankReconcilationStatement.vue";
import vatPaymentRecord from "@/views/module/accounts/vatBook/vatPaymentRecord.vue";
import taxPaymentRecord from "@/views/module/accounts/taxBook/taxPaymentRecord.vue";
import vatPaymentDetails from "@/views/module/accounts/vatBook/vatPaymentDetails.vue";
import taxPaymentDetails from "@/views/module/accounts/taxBook/taxPaymentDetails.vue";
import addMoneyRequisition from "@/views/module/accounts/moneyRequisition/addMoneyRequisition.vue";
import moneyRequisitionRecord from "@/views/module/accounts/moneyRequisition/moneyRequisitionRecord.vue";
import viewMoneyRequisition from "@/views/module/accounts/moneyRequisition/viewMoneyRequisition.vue";
import employeeAdvanceRecord from "@/views/module/accounts/employeeAdvanceRecord/employeeAdvanceRecord.vue";
import chequeBookSetup from "@/views/module/accounts/chequeBook/chequeBookSetup.vue";
import bankSetup from "@/views/module/accounts/chequeBook/bankSetup.vue";
import bankBranchSetup from "@/views/module/accounts/chequeBook/bankBranchSetup.vue";
import bankAccountSetup from "@/views/module/accounts/chequeBook/bankAccountSetup.vue";


export default [
  {
    path: "/account",
    name: "account",
    component: LayoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: "Account Management",
    },
    children: [
      {
        path: "chart-of-account",
        name: "chart-of-account",
        meta: {
          breadcrumb: ["Account Management", "Chart of Accounts"],
        },
        component: chartOfAccountSetup,
      },
      {
        path: "cost-center",
        name: "cost-center",
        meta: {
          breadcrumb: ["Account Management", "Cost Center"],
        },
        component: costCenterSetup,
      },
      {
        path: "add-journal",
        name: "add-journal",
        meta: {
          breadcrumb: ["Account Management", "Add Journal Voucher"],
        },
        component: addJournalVoucher,
      },
      {
        path: "bank-setup",
        name: "bank-setup",
        meta: {
          breadcrumb: ["Account Management", "Bank Setup"],
        },
        component: bankSetup,
      },
      {
        path: "bank-branch-setup",
        name: "bank-branch-setup",
        meta: {
          breadcrumb: ["Account Management", "Bank Branch Setup"],
        },
        component: bankBranchSetup,
      },
      {
        path: "bank-account-setup",
        name: "bank-account-setup",
        meta: {
          breadcrumb: ["Account Management", "Bank Account Setup"],
        },
        component: bankAccountSetup,
      },
      {
        path: "bank-branch-setup",
        name: "bank-branch-setup",
        meta: {
          breadcrumb: ["Account Management", "Bank Branch Setup"],
        },
        component: bankBranchSetup,
      },
      {
        path: "cheque-book-setup",
        name: "cheque-book-setup",
        meta: {
          breadcrumb: ["Account Management", "Cheque Book"],
        },
        component: chequeBookSetup,
      },
      {
        path: "journal-voucher-record",
        name: "journal-voucher-record",
        meta: {
          breadcrumb: ["Account Management", "Journal Vourcher List"],
        },
        component: journalVoucherList,
      },
      
      {
        path: "view-journal-voucher/:id",
        name: "view-journal-voucher",
        meta: {
          breadcrumb: ["Account Management", "View Journal Voucher"],
        },
        component: viewJournalVoucher,
      },

      {
        path: "add-receipt-voucher",
        name: "add-receipt-voucher",
        meta: {
          breadcrumb: ["Account Management", "Add Receipt Voucher"],
        },
        component: addReceiptVoucher,
      },
      {
        path: "receipt-voucher-record",
        name: "receipt-voucher-record",
        mata: {
          breadcrumb: ["Account Management", "Receipt Voucher List"],
        },
        component: receiptVoucherList,
      },
      {
        path: "view-receipt-voucher/:id",
        name: "view-receipt-voucher",
        meta: {
          breadcrumb: ["Account Management", "View Receipt Voucher"],
        },
        component: viewReceiptVoucher,
      },

      {
        path: "add-contra-voucher",
        name: "add-contra-voucher",
        meta: {
          breadcrumb: ["Account Management", "Add Contra Voucher"],
        },
        component: addcontraVoucher,
      },

      {
        path: "contra-voucher-record",
        name: "contra-voucher-record",
        meta: {
          breadcrumb: ["Account Management", "Contra Voucher List"],
        },
        component: contraVoucherList,
      },

      {
        path: "view-contra-voucher/:id",
        name: "view-contra-voucher",
        meta: {
          breadcrumb: ["Account", "View Contra Voucher"],
        },
        component: viewContraVoucher,
      },

      {
        path: "add-refund-receive-voucher",
        name: "add-refund-receive-voucher",
        meta: {
          breadcrumb: ["Account Management", "Add Refund Voucher"],
        },
        component: addRefundReceiveVoucher,
      },

      {
        path: "refund-receive-voucher-record",
        name: "refund-receive-voucher-record",
        meta: {
          breadcrumb: ["Account Management", "Refund Voucher List"],
        },
        component: refundReceiveVoucherList,
      },

      {
        path: "view-refund-receive-voucher/:id",
        name: "view-refund-receive-voucher",
        meta: {
          breadcrumb: ["Account Management", "View Refund Receive Voucher"],
        },
        component: viewRefundReceiveVoucher,
      },

      {
        path: "balance-sheet",
        name: "balance-sheet",
        meta: {
          breadcrumb: ["Account Management", "Balance Sheet"],
        },
        component: balanceSheet,
      },

      {
        path: "income-statement",
        name: "income-statement",
        meta: {
          breadcrumb: ["Account Management", "Income Statement"],
        },
        component: incomeStatement,
      },

      {
        path: "trial-balance",
        name: "trial-balance",
        meta: {
          breadcrumb: ["Account Management", "Trial Balance"],
        },
        component: trialBalance,
      },

      {
        path: "general-ledger",
        name: "general-ledger",
        meta: {
          breadcrumb: ["Account Management", "General Ledger"],
        },
        component: ledger,
      },
    {
        path: "customer-ledger",
        name: "customer-ledger",
        meta: {
            breadcrumb: ["Account Management", "Customer Ledger"],
        },
        component: customerLedger,
    },
    {
        path: "supplier-ledger",
        name: "supplier-ledger",
        meta: {
            breadcrumb: ["Account Management", "Supplier Ledger"],
        },
        component: supplierLedger,
    },

      {
        path: "cashbook",
        name: "cashbook",
        meta: {
          breadcrumb: ["Account Management", "Cash Book"],
        },
        component: cashBook,
      },

      {
        path: "bankbook",
        name: "bankbook",
        meta: {
          breadcrumb: ["Account Management", "Bank Book"],
        },
        component: bankBook,
      },

      {
        path: "receipt-payment-statement",
        name: "receipt-payment-statement",
        meta: {
          breadcrumb: ["Account Management", "Receipt Payment Statement"],
        },
        component: receiptPaymentStatement,
      },

      {
        path: "day-book",
        name: "day-book",
        meta: {
          breadcrumb: ["Account Management", "Day Book"],
        },
        component: dayBook,
      },

      {
        path: "cash-flow",
        name: "cash-flow",
        meta: {
          breadcrumb: ['Account Management', 'Cash Flow']
        },
        component: cashFlowStatement
      },

      {
        path: "report/changes-in-equity",
        name: "changes-in-equity",
        meta: {
          breadcrumb: ['Account Management', 'Changes in Equity']
        },
        component: changesInEquity
      },



      {
        path: "add-payment-voucher",
        name: "add-payment-voucher",
        meta: {
          breadcrumb: ["Account Management", "Add Payment Voucher"],
        },
        component: addPaymentVoucher,
      },

      {
        path: "payment-voucher-record",
        name: "payment-voucher-record",
        meta: {
          breadcrumb: ["Account Management", "Payment Voucher List"],
        },
        component: paymentVoucherList,
      },

      {
        path: "view-payment-voucher/:id",
        name: "view-payment-voucher",
        meta: {
          breadcrumb: ["Account Management", "View Payment Voucher"],
        },
        component: viewPaymentVoucher,
      },

      {
        path: "add-refund-pay-voucher",
        name: "add-refund-pay-voucher",
        meta: {
          breadcrumb: ["Account Management", "Add Refund Pay Voucher"],
        },
        component: addRefundPayVoucher,
      },

      {
        path: "refund-pay-voucher-record",
        name: "refund-pay-voucher-record",
        meta: {
          breadcrumb: ["Account Management", "Refund Pay Voucher List"],
        },
        component: refundPayVoucherList,
      },

      {
        path: "view-refund-pay-voucher/:id",
        name: "view-refund-pay-voucher",
        meta: {
          breadcrumb: ["Account Management", "View Refund Pay Voucher"],
        },
        component: viewRefundPayVoucher,
      },

      {
        path: "add-debit-note-voucher",
        name: "add-debit-note-voucher",
        meta: {
          breadcrumb: ["Account Management", "Add Debit Note Voucher"],
        },
        component: addDebitNoteVoucher,
      },

      {
        path: "debit-note-voucher-record",
        name: "debit-note-voucher-record",
        meta: {
          breadcrumb: ["Account Management", "Debit Note Voucher List"],
        },
        component: debitNoteVoucherList,
      },

      {
        path: "view-debit-note-voucher/:id",
        name: "view-debit-note-voucher",
        meta: {
          breadcrumb: ["Account Management", "View Debit Note Voucher"],
        },
        component: viewDebitNoteVoucher,
      },

      {
        path: "add-credit-note-voucher",
        name: "add-credit-note-voucher",
        meta: {
          breadcrumb: ["Account Management", "Add Credit Voucher List"],
        },
        component: addCreditNoteVoucher,
      },

      {
        path: "credit-note-voucher-record",
        name: "credit-note-voucher-record",
        meta: {
          breadcrumb: ["Account Management", "Credit Note Voucher List"],
        },
        component: creditNoteVoucherList,
      },
      {
        path: "view-credit-note-voucher/:id",
        name: "view-credit-note-voucher",
        meta: {
          breadcrumb: ["Account Management", "View Credit Note Voucher"],
        },
        component: viewCreditNoteVoucher,
      },

      {
        path: "add-purchase-voucher",
        name: "add-purchase-voucher",
        meta: {
          breadcrumb: ["Account Management", "Add Purchase Voucher"],
        },
        component: addPurchaseVoucher,
      },

      {
        path: "purchase-voucher-record",
        name: "purchase-voucher-record",
        meta: {
          breadcrumb: ["Account Management", "Purchase Voucher List"],
        },
        component: purchaseVoucherList,
      },
      {
        path: "view-purchase-voucher/:id",
        name: "view-purchase-voucher",
        meta: {
          breadcrumb: ["Account Management", "View Purchase Voucher"],
        },
        component: viewPurchaseVoucher,
      },

      {
        path: "add-sales-voucher",
        name: "add-sales-voucher",
        meta: {
          breadcrumb: ["Account Management", "Add Sales Voucher"],
        },
        component: addSalesVoucher,
      },

      {
        path: "sales-voucher-record",
        name: "sales-voucher-record",
        meta: {
          breadcrumb: ["Account Management", "Sales Voucher List"],
        },
        component: salesVoucherList,
      },

      {
        path: "view-sales-voucher/:id",
        name: "view-sales-voucher",
        meta: {
          breadcrumb: ["Account Management", "View Sales Voucher"],
        },
        component: viewSalesVoucher,
      },

      {
        path: "add-opening-balance-voucher",
        name: "add-opening-balance-voucher",
        meta: {
          breadcrumb: ["Account Management" , "Add Opening Balance"]
        },
        component: addOpeningBalanceVoucher,
      },

      {
        path: "opening-balance-voucher-record",
        name: "opening-balance-voucher-record",
        meta: {
          breadcrumb: ["Account Management" , "Opening Balance List"],
        },
        component: openingBalanceVoucherList,
      },

      {
        path: "view-opening-balance-voucher/:id",
        name: "view-opening-balance-voucher",
        meta: {
          breadcrumb: ["Account Management" , "View Opening Balance"],
        },
        component: viewOpeningBalanceVoucher,
      },

      {
        path: "payee-depositor-party",
        name: "payee-depositor-party",
        meta: {
          breadcrumb: ["Account Management", "Payee/Depositor/Party"],
        },
        component: payeeDepositorParty,
      },
      {
        path: "vat-book/vat-register",
        name: "vat-book/vat-register",
        meta: {
          breadcrumb: ["Account Management", "VAT Register"],
        },
        component: vatRegister,
      },
      {
        path: "tax-book/tax-register",
        name: "tax-book/tax-register",
        meta: {
          breadcrumb: ["Account Management", "TAX Register"],
        },
        component: taxRegister,
      },
      {
        path: "bank-reconciliation",
        name: "bank-reconciliation",
        meta: {
          breadcrumb: ["Account Management", "Bank Reconciliation Record"],
        },
        component: bankReconcilationRecord,
      },
      {
        path: "bank-reconciliation-statement",
        name: "bank-reconciliation-statement",
        meta: {
          breadcrumb: ["Account Management", "Bank Reconciliation Record"],
        },
        component: bankReconcilationStatement,
      },
      {
        path: "vat-payemnt-record",
        name: "vat-payemnt-record",
        meta: {
          breadcrumb: ["Account Management", "VAT Payment Record"],
        },
        component: vatPaymentRecord,
      },
      {
        path: "tax-payemnt-record",
        name: "tax-payemnt-record",
        meta: {
          breadcrumb: ["Account Management", "TAX Payment Record"],
        },
        component: taxPaymentRecord,
      },
      {
        path: "vat-payemnt-details",
        name: "vat-payemnt-details",
        meta: {
          breadcrumb: ["Account Management", "VAT Payment Details"],
        },
        component: vatPaymentDetails,
      },
      {
        path: "tax-payemnt-details",
        name: "tax-payemnt-details",
        meta: {
          breadcrumb: ["Account Management", "TAX Payment Details"],
        },
        component: taxPaymentDetails,
      },
      {
        path: "add-money-requisition",
        name: "add-money-requisition",
        meta: {
          breadcrumb: ["Account Management", "Add Money Requisition"],
        },
        component: addMoneyRequisition,
      },
      {
        path: "money-requisition-record",
        name: "money-requisition-record",
        meta: {
          breadcrumb: ["Account Management", "Money Requisition Record"],
        },
        component: moneyRequisitionRecord,
      },
      {
        path: "employee-advance-record",
        name: "employee-advance-record",
        meta: {
          breadcrumb: ["Account Management", "Employee Advance Record"],
        },
        component: employeeAdvanceRecord,
      },
      {
        path: "view-money-requisition/:id",
        name: "view-money-requisition",
        meta: {
          breadcrumb: ["Account Management", "View Money Requisition"],
        },
        component: viewMoneyRequisition,
      },

      
      
    ],
  },
];
